module.exports = __webpack_public_path__ + "static/media/arrow_right.b57d2b60.svg";